import React, { useRef, useEffect } from "react";
import classes from "./TinyMCEViewer.module.css"
import { logError } from "../../lms-shared/errors/error";
const TinyMCEViewer = ({ data, contentDirPath, html }) => {
    const ref = useRef(null)
    useEffect(() => {
        (async () => {
            try {
                let innerHtmlText = '';
                if (!html) {
                    const innerHtml = await fetch(`${contentDirPath}${data}`);
                    if (innerHtml.ok) {
                        innerHtmlText = await innerHtml.text();
                    }
                }
                else {
                    innerHtmlText = html
                }
                if (ref.current){
                    ref.current.innerHTML = !innerHtmlText ? "" : innerHtmlText.replace(/#BASE_PATH_REPLACE#/g, contentDirPath);
                }
            }
            catch (error) {
                logError(error, "error in see quetion", "cmsTinyMce", "TinyMceViewer", "50", { data:data, contentDirPath, html })
            }
        })()
    }, [data, contentDirPath, html])

    return <div ref={ref} className={classes.TinyMCEViewer} >
    </div>
}

export default TinyMCEViewer;